import { defineComponent as R, mergeModels as z, useModel as h, getCurrentInstance as E, useTemplateRef as g, provide as G, createBlock as i, openBlock as t, resolveDynamicComponent as S, mergeProps as K, unref as d, withCtx as n, createVNode as o, createElementBlock as N, createCommentVNode as p, Fragment as U, createTextVNode as F, toDisplayString as H, normalizeClass as D, renderSlot as T, nextTick as j } from "vue";
import q from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/TextInputGroup/text-input-group.js";
import { useChildrenTracker as X } from "../../use/children-tracker.js";
import J from "../InputGroup/InputGroup.vue2.js";
import Q from "../TextInputGroup/TextInputGroup.vue2.js";
import W from "../TextInputGroup/TextInputGroupMain.vue2.js";
import Y from "../TextInputGroup/TextInputGroupUtilities.vue2.js";
import Z from "./AdvancedSearchMenu.vue2.js";
import x from "../Badge.vue2.js";
import b from "../Button.vue2.js";
import C from "../../helpers/PassThrough.vue2.js";
import _ from "../../helpers/FloatingUi.vue2.js";
import { useOUIAProps as ee } from "../../helpers/ouia.js";
import { MagnifyingGlassIcon as V } from "../../packages/icons/dist/esm/icons/magnifying-glass-icon.js";
import { XmarkIcon as $ } from "../../packages/icons/dist/esm/icons/xmark-icon.js";
import { AngleUpIcon as ae } from "../../packages/icons/dist/esm/icons/angle-up-icon.js";
import { AngleDownIcon as le } from "../../packages/icons/dist/esm/icons/angle-down-icon.js";
import { CaretDownIcon as ne } from "../../packages/icons/dist/esm/icons/caret-down-icon.js";
import { ArrowRightIcon as te } from "../../packages/icons/dist/esm/icons/arrow-right-icon.js";
import { FormInputsKey as oe } from "../Form/common.js";
const re = Symbol("SearchInputKey"), Ne = /* @__PURE__ */ R({
  name: "PfSearchInput",
  inheritAttrs: !1,
  __name: "SearchInput",
  props: /* @__PURE__ */ z({
    disabled: { type: Boolean, default: !1 },
    ariaLabel: { default: "Search input" },
    placeholder: {},
    hint: {},
    type: { default: "text" },
    zIndex: {},
    resetButtonLabel: { default: "Reset" },
    submitSearchButtonLabel: { default: "Search" },
    openMenuButtonAriaLabel: { default: "Open advanced search" },
    previousNavigationButtonAriaLabel: { default: "Previous" },
    previousNavigationButtonDisabled: { type: Boolean, default: !1 },
    nextNavigationButtonAriaLabel: { default: "Next" },
    nextNavigationButtonDisabled: { type: Boolean, default: !1 },
    resultsCount: {},
    attributes: { default: () => [] },
    expandable: { type: Boolean },
    expandButtonAriaLabel: {},
    advancedSearchDelimiter: {},
    appendTo: {},
    onClear: {},
    onNextClick: {},
    onPreviousClick: {},
    onToggleAdvancedSearch: {},
    onSearch: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    modelValue: { default: "" },
    modelModifiers: {},
    advancedSearchOpen: { type: Boolean, default: !1 },
    advancedSearchOpenModifiers: {},
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:modelValue", "update:advancedSearchOpen", "update:expanded"],
  setup(c) {
    var L;
    const a = c, w = ee({ id: a.ouiaId, safe: a.ouiaSafe }), u = h(c, "modelValue"), f = h(c, "advancedSearchOpen"), m = h(c, "expanded");
    a.attributes.length > 0 && !a.advancedSearchDelimiter && console.error(
      "An advancedSearchDelimiter prop is required when advanced search attributes are provided using the attributes prop"
    ), X(oe, (L = E()) == null ? void 0 : L.proxy);
    const y = g("elRef"), k = g("expandButtonRef"), v = g("inputRef");
    G(re, {
      $el: y,
      input: v
    });
    function B(e) {
      var l;
      f.value = !f.value, (l = a.onToggleAdvancedSearch) == null || l.call(a, e, f.value);
    }
    function A(e) {
      var l;
      f.value = !1, (l = a.onSearch) == null || l.call(a, u.value, e, I());
    }
    function I() {
      const e = {};
      return u.value.split(" ").map((r) => {
        const s = a.advancedSearchDelimiter ? r.split(a.advancedSearchDelimiter) : [];
        s.length === 2 ? e[s[0]] = s[1] : s.length === 1 && (e.haswords = Object.hasOwnProperty.call(e, "haswords") ? `${e.haswords} ${s[0]}` : s[0]);
      }), e;
    }
    function M(e) {
      e.key === "Enter" && A(e);
    }
    function P(e) {
      var l, r;
      (l = a.onClear) == null || l.call(a, e), (r = v.value) == null || r.focus();
    }
    function O(e) {
      var l;
      u.value = "", (l = a.onClear) == null || l.call(a, e), m.value = !m.value, j(() => {
        var r, s;
        m.value ? (r = v.value) == null || r.focus() : ((s = k.value) == null ? void 0 : s.el) instanceof HTMLElement && k.value.el.focus();
      });
    }
    return (e, l) => (t(), i(S(e.attributes.length > 0 ? "div" : C), K(d(w), { ref: "elRef" }), {
      default: n(() => [
        (t(), i(S(e.onSearch || e.attributes.length > 0 || e.onToggleAdvancedSearch || e.expandable ? J : C), null, {
          default: n(() => [
            !e.expandable || m.value ? (t(), N(U, { key: 0 }, [
              o(Q, { disabled: e.disabled }, {
                default: n(() => [
                  o(W, {
                    ref: "inputRef",
                    modelValue: u.value,
                    "onUpdate:modelValue": l[0] || (l[0] = (r) => u.value = r),
                    type: e.type,
                    hint: e.hint,
                    placeholder: e.placeholder,
                    "aria-label": e.ariaLabel,
                    onKeydown: M
                  }, {
                    icon: n(() => [
                      o(d(V))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "type", "hint", "placeholder", "aria-label"]),
                  u.value && (e.resultsCount || e.onNextClick && e.onPreviousClick || e.onClear && !e.expandable) ? (t(), i(Y, { key: 0 }, {
                    default: n(() => [
                      e.resultsCount ? (t(), i(x, {
                        key: 0,
                        read: ""
                      }, {
                        default: n(() => [
                          F(H(e.resultsCount), 1)
                        ]),
                        _: 1
                      })) : p("", !0),
                      e.onNextClick && e.onPreviousClick ? (t(), N("div", {
                        key: 1,
                        class: D(d(q).textInputGroupGroup)
                      }, [
                        o(b, {
                          disabled: e.disabled || e.previousNavigationButtonDisabled,
                          "aria-label": e.previousNavigationButtonAriaLabel,
                          onClick: e.onPreviousClick
                        }, {
                          default: n(() => [
                            o(d(ae))
                          ]),
                          _: 1
                        }, 8, ["disabled", "aria-label", "onClick"]),
                        o(b, {
                          variant: "plain",
                          disabled: e.disabled || e.nextNavigationButtonDisabled,
                          "aria-label": e.nextNavigationButtonAriaLabel,
                          onClick: e.onNextClick
                        }, {
                          default: n(() => [
                            o(d(le))
                          ]),
                          _: 1
                        }, 8, ["disabled", "aria-label", "onClick"])
                      ], 2)) : p("", !0),
                      e.onClear && !e.expandable ? (t(), i(b, {
                        key: 2,
                        variant: "plain",
                        disabled: e.disabled,
                        "aria-label": e.resetButtonLabel,
                        onClick: P
                      }, {
                        default: n(() => [
                          o(d($))
                        ]),
                        _: 1
                      }, 8, ["disabled", "aria-label"])) : p("", !0)
                    ]),
                    _: 1
                  })) : p("", !0)
                ]),
                _: 1
              }, 8, ["disabled"]),
              e.attributes.length > 0 || e.onToggleAdvancedSearch ? (t(), i(b, {
                key: 0,
                class: D({ "pf-m-expanded": f.value }),
                variant: "control",
                disabled: e.disabled,
                "aria-label": e.openMenuButtonAriaLabel,
                "aria-expanded": f.value,
                onClick: B
              }, {
                default: n(() => [
                  o(d(ne))
                ]),
                _: 1
              }, 8, ["class", "disabled", "aria-label", "aria-expanded"])) : p("", !0),
              e.onSearch ? (t(), i(b, {
                key: 1,
                type: "submit",
                variant: "control",
                disabled: e.disabled || !u.value,
                "aria-label": e.submitSearchButtonLabel,
                onClick: A
              }, {
                default: n(() => [
                  o(d(te))
                ]),
                _: 1
              }, 8, ["disabled", "aria-label"])) : p("", !0)
            ], 64)) : p("", !0),
            e.expandable ? (t(), i(b, {
              key: 1,
              ref: "expandButtonRef",
              variant: "plain",
              "aria-label": e.expandButtonAriaLabel,
              "aria-expanded": m.value,
              onClick: O
            }, {
              default: n(() => [
                m.value ? (t(), i(d($), { key: 0 })) : (t(), i(d(V), { key: 1 }))
              ]),
              _: 1
            }, 8, ["aria-label", "aria-expanded"])) : p("", !0)
          ]),
          _: 1
        })),
        o(_, {
          hidden: !e.attributes.length,
          "teleport-to": e.appendTo,
          reference: d(y),
          "z-index": e.zIndex,
          flip: ""
        }, {
          default: n(() => [
            (t(), i(S(e.appendTo === "inline" ? C : "div"), null, {
              default: n(() => [
                o(Z, {
                  modelValue: u.value,
                  "onUpdate:modelValue": l[1] || (l[1] = (r) => u.value = r),
                  "reset-button-label": e.resetButtonLabel,
                  "submit-search-button-label": e.submitSearchButtonLabel,
                  attributes: e.attributes,
                  "advanced-search-delimiter": e.advancedSearchDelimiter,
                  "get-attr-value-map": I,
                  "search-menu-open": f.value,
                  onSearch: e.onSearch,
                  onClear: e.onClear,
                  onToggleAdvancedMenu: B
                }, {
                  "words-attr-label": n(() => [
                    T(e.$slots, "words-attr-label")
                  ]),
                  default: n(() => [
                    T(e.$slots, "form-additional-items")
                  ]),
                  _: 3
                }, 8, ["modelValue", "reset-button-label", "submit-search-button-label", "attributes", "advanced-search-delimiter", "search-menu-open", "onSearch", "onClear"])
              ]),
              _: 3
            }))
          ]),
          _: 3
        }, 8, ["hidden", "teleport-to", "reference", "z-index"])
      ]),
      _: 3
    }, 16));
  }
});
export {
  re as SearchInputKey,
  Ne as default
};
